<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  created() {},
  methods: {}
}
</script>

<style lang="less" scope>
@import url("~@/assets/css/main.less");

#app {
  width: 100%;
  height: 100%;
}
</style>
